import {ChangeDetectorRef, Component, DoCheck, EventEmitter, Input, Output} from '@angular/core';
import ArticleGroup from '../../../smoothr-web-app-core/models/ArticleGroup';
import {OrderListAction} from '../../enums/OrderListAction';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import {DisplayIdentifier} from '../../../smoothr-web-app-core/enums/DisplayIdentifier';
import {OrderUtils} from '../../../smoothr-web-app-core/utils/order-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import {ValidationUtils} from '../../../smoothr-web-app-core/utils/validation-utils';
import Order from '../../../smoothr-web-app-core/models/Order';
import {numberD, numberToCurrency} from '../../../smoothr-web-app-core/utils/utils';
import {RepositoryService} from 'src/smoothr-web-app-core/services/repository/repository.service';
import {FavouriteModalOnAddComponent} from '../favourite-modal-on-add/favourite-modal-on-add.component';
import {ModalController} from '@ionic/angular';
import Localization from 'src/smoothr-web-app-core/models/Localization';
import SubscriptionArticles from 'src/smoothr-web-app-core/models/Subscription';

@Component({
	selector: 'app-order-list',
	templateUrl: './order-list.component.html',
	styleUrls: ['order-list.component.scss']
})
export class OrderListComponent implements DoCheck {
	@Output() action = new EventEmitter<OrderListAction>();
	@Input() editable = true;
	@Input() index: number;
	@Input() subscriptionUser: SubscriptionArticles[] = [];
	OrderUtils = OrderUtils;
	isSomeOptionFullPrice = false;
	needsConfiguration = false;
	articleGroupPrice = 0;
	priceWithDiscount = 0;
	numberToCurrency = numberToCurrency;
	private prevPromoState = false;
	private prevQuantity = 1;
	numberD = numberD;
	public isArticleIsSubscription: boolean = false;
	constructor(
		private cd: ChangeDetectorRef,
		private repository: RepositoryService,
		private modalCtrl: ModalController
	) {}

	private _articleGroup: ArticleGroup;

	get articleGroup(): ArticleGroup {
		return this._articleGroup;
	}

	@Input()
	set articleGroup(value: ArticleGroup) {
		this._articleGroup = value;
		this.reloadArticle();
	}

	private _order: Order;

	get order(): Order {
		return this._order;
	}

	@Input()
	set order(value: Order) {
		this._order = value;
		this.reloadArticle();
	}

	edit() {
		if (!this.isEditable()) {
			return;
		}
		this.action.emit(OrderListAction.edit);
	}

	isEditable(): boolean {
		return this.editable;
	}

	delete() {
		if (!this.isEditable()) {
			return;
		}
		this.action.emit(OrderListAction.delete);
	}

	async note() {
		if (!this.editable) {
			return;
		}
		this.action.emit(OrderListAction.note);
	}

	add() {
		if (!this.isEditable()) {
			return;
		}
		this.action.emit(OrderListAction.add);
	}

	remove() {
		if (!this.isEditable()) {
			return;
		}
		this.action.emit(OrderListAction.remove);
	}

	isOptionFullPrice(articleOption: ArticleOption): boolean {
		const group = this.articleGroup.article.groups.find(grp => grp._id === articleOption.group);
		return (
			group &&
			group.displayIdentifiers &&
			group.displayIdentifiers.findIndex(di => DisplayIdentifier.fullPrice === di) >= 0
		);
	}

	hiddenInCart(article: Article): boolean {
		return article.tags && article.tags.find(tag => tag.identifier === 'hide_cart') !== undefined;
	}

	reloadArticle() {
		this.needsConfiguration = false;
		this.isSomeOptionFullPrice = false;
		this.articleGroupPrice = 0;
		this.prevPromoState = false;
		this.prevQuantity = 1;
		if (!this.articleGroup || !this.order || !this.order.preorder) {
			this.articleGroupPrice = 0;
			return;
		}
		this.prevQuantity = this.articleGroup.quantity;
		this.prevPromoState = this.articleGroup.isPromo;
		this.needsConfiguration = !ValidationUtils.areGroupsValid(this.articleGroup, this.articleGroup.article.groups);
		for (const articleOption of this.articleGroup.groups) {
			if (this.isOptionFullPrice(articleOption)) {
				this.isSomeOptionFullPrice = true;
			}
		}
		this.articleGroupPrice = OrderUtils.totalPrice(this.articleGroup, this.order.type, this.order.preorder.type);
		if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && this.articleGroup.isPromo) {
			this.articleGroupPrice -= OrderUtils.bogoPrice(this.articleGroup, this.order.type, this.order.preorder.type);
		}
		this.priceWithDiscount = OrderUtils.priceOfSubscriptionArticle(
			this.order.orderedSubscriptionArticles,
			this.index,
			this.order.type,
			this.order.preorder.type,
			null,
			this.subscriptionUser
		);
		// this.isArticleIsSubscription = false;
		// if (this.order.orderedSubscriptionArticles.find(it => it.article._id === this.articleGroup.article._id)) {
		// 	this.articleGroupPrice = 0;
		// 	this.isArticleIsSubscription = true;
		// }
	}

	ngDoCheck(): void {
		if (this.prevPromoState !== this.articleGroup.isPromo) {
			this.reloadArticle();
			this.cd.markForCheck();
		}
		if (this.prevQuantity !== this.articleGroup.quantity) {
			this.reloadArticle();
			this.cd.markForCheck();
		}
	}
	// favourites are stored by article._id - the same key the menu list and the
	// favourites page use
	async addToFavourite(articleId: string, articleName: Localization) {
		if (this.isArticleFavourite(articleId)) {
			this.repository.deleteFavourite(articleId);
		} else {
			await FavouriteModalOnAddComponent.show(this.modalCtrl, articleName);
			this.repository.addFavourite(articleId);
		}
	}
	isArticleFavourite(articleId: string) {
		return this.repository.checkIfArticleIsFavourite(articleId);
	}
	isArticleInSubscription(article: Article): boolean {
		return !!this.subscriptionUser.find(it => it.articles.includes(article._id));
	}
	showSubscription(article: Article) {
		return this.subscriptionUser.find(it => it.articles.includes(article._id));
	}
}
